import { DepartamentModel } from 'src/app/domain/models/departament.model';

export interface DepartamentState {
    departaments: DepartamentModel[];
}

export const initialDepartamentState: DepartamentState = {
    departaments: [],
};
